var _excluded = ["alignItems", "basis", "direction", "gap", "grow", "flex", "inline", "justifyContent", "shrink", "wrap"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import { Box } from '../Box/Box';
/**
 * `Flex` is a wrapper around `Box` defaulting to display flex CSS
 * and providing shorter prop names (e.g. `shrink` instead of `flexShrink`).
 * `Box` can mimic anything `Flex` can.
 */
export var Flex = /*#__PURE__*/React.forwardRef(function Flex(_ref, ref) {
  var _ref$alignItems = _ref.alignItems,
    alignItems = _ref$alignItems === void 0 ? 'flex-start' : _ref$alignItems,
    basis = _ref.basis,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'row' : _ref$direction,
    gap = _ref.gap,
    grow = _ref.grow,
    flex = _ref.flex,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    _ref$justifyContent = _ref.justifyContent,
    justifyContent = _ref$justifyContent === void 0 ? 'flex-start' : _ref$justifyContent,
    shrink = _ref.shrink,
    wrap = _ref.wrap,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, _extends({}, props, {
    ref: ref,
    display: inline ? 'inline-flex' : 'flex',
    alignItems: alignItems,
    justifyContent: justifyContent,
    flexBasis: basis,
    flexDirection: direction,
    flexGrow: grow,
    flexShrink: shrink,
    flexWrap: wrap,
    flex: flex,
    gap: gap
  }));
});
Flex.displayName = 'Flex';
//# sourceMappingURL=Flex.js.map